import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import MoreMenu from '../common/moreMenu';
import './videoCSS.css';
import { addMemberToScreen, removeMemberFromScreen } from '../../redux/reducers';
import { isChatAdmin } from '../../utils/user/user';
import { AdminCommands } from '../../twilio/adminCommands';
import { useTrackEnabled } from '../../twilio/hooks';

const ParticipantMenu = ({ member, isSmall, ...props }) => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);

  const items = isSmall
    ? [
        {
          i18nKey: 'chat.moveUp',
          action: useCallback(() => {
            dispatch(addMemberToScreen(member));
          }),
        },
      ]
    : [
        {
          i18nKey: 'chat.moveDown',
          action: useCallback(() => {
            dispatch(removeMemberFromScreen(member.id));
          }),
        },
      ];

  const muteAction = useCallback(() => {
    dispatch(AdminCommands.muteParticipant(member.name));
  });

  const name = member && member.name;
  const trackSelector = useCallback(
    (track, participant) => {
      return participant.identity === name && track.kind === 'audio';
    },
    [name]
  );
  const isAudioEnabled = useTrackEnabled(trackSelector);
  if (isChatAdmin(userData) && isAudioEnabled && !member.isSelf) {
    items.push({
      i18nKey: 'chat.mute',
      action: muteAction,
    });
  }

  return <MoreMenu items={items} {...props} />;
};

ParticipantMenu.propTypes = {
  member: PropTypes.object,
  isSmall: PropTypes.bool,
};

export default ParticipantMenu;
